import { entity, Plugin } from 'simpler-state';

import entityReduxLogger from '../debug/helpers/entity-redux-logger';
import { NullableNumber, NullableString } from '../util/types';

export type ChartHoverData = {
  price: NullableNumber;
  time: NullableString;
  volume: NullableNumber;
  isHovering: boolean;
};

const INITIAL_STATE: ChartHoverData = {
  price: null,
  time: null,
  volume: null,
  isHovering: false,
};

const plugins: Plugin[] = entityReduxLogger('ChartHover', 'chart-hover') ?? [];
const ChartHoverCache = entity<ChartHoverData>(
  INITIAL_STATE,
  plugins,
);

export const setChartHoverData = (data: Partial<ChartHoverData>) => {
  ChartHoverCache.set({ ...ChartHoverCache.get(), ...data });
};

export const clearChartHoverData = () => {
  ChartHoverCache.set(INITIAL_STATE);
};

export default {
  use: ChartHoverCache.use,
  get: ChartHoverCache.get,
  set: setChartHoverData,
  clear: clearChartHoverData,
};
